export const UPDATE = '@intl/UPDATE';
export const REMOVE = '@intl/REMOVE';
